import React from 'react';
import PropTypes from 'prop-types';
import SidebarDetailHeader from '../SidebarDetailHeader';
import ImportSection from './ImportSection';
import ExportSection from './ExportSection';
import ImportedFeatures from './ImportedFeatures';
import { connect } from 'dva';
import SidebarBody from '../SidebarBody';

export function DataManager(props) {
  return (
    <>
      <SidebarDetailHeader
        title="Data Manager"
        descriptionText="Import and export all your waypoints, lines, and areas into and out of Maps in one seamless experience."
      />
      <SidebarBody>
        { !props.importError && props.importedFeatures && props.importedFeatures.length > 0 ?
          <ImportedFeatures /> :
          <>
            <ImportSection />
            <ExportSection />
          </>
        }
      </SidebarBody>
    </>
  );
}

DataManager.propTypes = {
  importError: PropTypes.any,
  importedFeatures: PropTypes.array,
  isImporting: PropTypes.bool
};

export default connect((model) => ({
  importError: model.dataManager.importError,
  importedFeatures: model.dataManager.importedFeatures,
  isImporting: model.dataManager.isImporting
}))(DataManager);